<template>
  <div class="flex flex-row items-center justify-between gap-8 h-12 bg-[#EEF2F4] rounded-lg mr-4 py-0 px-2 w-full">
    <div class="flex">
      <div
        class="device-icon-holder bg-[rgb(50,95,128)] p-2 w-[35px] h-[35px] rounded-full mr-4 hover:cursor-pointer hover:scale-105 transition-transform duration-100 ease-in-out"
      >
        <img
          :src="lobasIcon"
          class="device-icon"
        >
      </div>

      <div class="flex flex-col justify-center gap-0.5">
        <span class="text-xs text-[#2D3032] font-normal leading-[14px]">{{ $t('device.active') }}</span>
        <span class="text-sm text-[#2D3032] font-bold leading-[17px]">{{ device?.name }}</span>
      </div>
    </div>
    <div class="flex">
      <Button
        v-tooltip.bottom="{ value: $t('device.exit_device'), disabled: isMobile }"
        severity="secondary"
        variant=""
        aria-label="Exit Device"
        icon="pi pi-sign-out"
        class="mr-2"
        @click="$emit('exit')"
      />
      <Button
        v-tooltip.bottom="{ value: $t('settings.settings'), disabled: isMobile }"
        severity="secondary"
        variant=""
        aria-label="Settings"
        icon="pi pi-cog"
        @click="$emit('edit')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import lobasIconUrl from '@/assets/icons/home_energy_white.svg';

export default defineComponent({
  name: 'ActiveDeviceBar',
  components: { Button },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    device: {
      type: Object as PropType<{ id?: string; name?: string; type?: string } | null>,
      default: null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['exit', 'edit'],
  setup() {
    return { lobasIcon: lobasIconUrl };
  },
});
</script>
